jQuery(document).ready(function($){

  var filter_search = window.location.search;
  var search_values = [];

  // Example: Get filter_option_price from URL
  const urlParams = new URLSearchParams(window.location.search);
  const priceFilter = urlParams.get('filter_option_price');

  const sortingFilter = urlParams.get('sort_by');
  
  if(priceFilter) {
    $('.filter-group-display__price-filter li.filter-group-display__list-item').each(function(){
      if($(this).find('input').val() == priceFilter){
        $(this).find('input').attr('checked', 'checked');
      }else{
        $(this).find('input').removeAttr('checked');
      }
    })
  }

  if(sortingFilter){
    $('.new_collection_wrapper .product-sorting-form-wrap .collectionsortSelect select option').each(function(){
      if($(this).val() == sortingFilter){
        $(this).attr('selected', 'selected');
      }else{
        $(this).removeAttr('selected');
      }
    })

    $('.product-filter-wrapper-mobile .sort-filter-grid ul.sortingForm li').each(function(){
      if($(this).attr('data-value') == sortingFilter){
        $(this).addClass('active')
      }else{
        $(this).removeClass('active');
      }
    })
  }

  $('.filter-group-display__list-item label input').change(function () {
    const $item = $(this).closest('.filter-group-display__list');
  
    // Check if it's NOT a price filter
    if (!$item.hasClass('filter-group-display__price-filter')) {
      if ($(this).is(':checked')) {
        $('.filter-group-display__submit input').trigger('click');
      }
    } else {
      // Handle price range selection
      const data_min_price = parseFloat($(this).attr('data-min')) || 0;
      const data_max_price = parseFloat($(this).attr('data-max')) || 0;
      const $priceRange = $(this).closest('.filter-group-options').find('.filter-group-display__price-range');

      const currentMax = $priceRange.find('.filter-group-display__price-range-from input').attr('max');

  
      if ($(this).is(':checked')) {
        $(this).siblings().removeAttr('checked');
        if (data_min_price > 0) {
          $priceRange.find('.filter-group-display__price-range-from input').val(data_min_price);
        }
  
        if (data_max_price > 0) {
          if(data_max_price > currentMax){
            $priceRange.find('.filter-group-display__price-range-to input').val(currentMax);
          }else{
            $priceRange.find('.filter-group-display__price-range-to input').val(data_max_price);
          }
         
        }
  
        // Trigger submit after setting price range
        $(this).closest('.filter-group-options').find('.filter-group-display__submit input').trigger('click');
      }
    }
  });


  $(document).on('click', '.new_collection_layout .filter-group .filter-group-label span.collapse-filter-group', function(){
    if(!$(this).closest('.filter-group').hasClass('collapse')){
      $(this).closest('.filter-group').addClass('collapse');
      $(this).html(`<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6.93994L8 10.9399L12 6.93994" stroke="#1F1F1F" stroke-linecap="round" stroke-linejoin="round"/></svg>`);
    }else{
      $(this).closest('.filter-group').removeClass('collapse');
      $(this).html(`<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5L5 1L9 5" stroke="#1F1F1F" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`);
    }
  })
  
  
  $('.new_collection_wrapper .collection-product-grid .collection-product-item .product_variants ul li').on('mouseover', function() {
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    var old_image = $(this).closest('.collection_product_variant').find('.product_variants_image').attr('data-main-image');
    var new_image = $(this).attr('data-image');
  
    if (new_image && new_image !== 'undefined') {
      $(this).closest('.collection_product_variant').find('.product_variants_image img').attr('src', new_image);
    }
  });



  const filterBtn = document.getElementById('mobileMainFilterBtn');
  const sortBtn = document.getElementById('mobileSortFilterBtn');
  const filterPanel = document.querySelector('.mobileFiltersPopup');
  const overlay = document.querySelector('.mobile-filter-overlay');
  const closeBtn = document.getElementById('closeFilterForm');

  const filterForm = document.querySelector('.mainCollectionGrid .collection_filter .filter-form')?.innerHTML;
  
  const target = document.querySelector('.mobileFiltersPopup .main-filter-grid .filter-form-mobile');
  if (target && filterForm) {
    target.innerHTML = filterForm;
  }

  // Show filter panel
  if(filterBtn){
    filterBtn.addEventListener('click', () => {
      filterPanel.classList.add('active');
      overlay.classList.add('active');
    });
  }


  // Optional: if sort panel is separate, toggle accordingly
  if(sortBtn){
    sortBtn.addEventListener('click', () => {
      const sortGrid = document.querySelector('.sort-filter-grid');
    
      if (sortGrid.style.display === 'block') {
        sortGrid.style.display = 'none';
      } else {
        sortGrid.style.display = 'block';
      }
      
    });
  }
  

  // Hide on overlay click
  if(overlay){
    overlay.addEventListener('click', () => {
      filterPanel.classList.remove('active');
      overlay.classList.remove('active');
    });
  }
 
  if(closeBtn){
    closeBtn.addEventListener('click', () => {
      filterPanel.classList.remove('active');
      overlay.classList.remove('active');
    });
  }
 

   $(document).on('click', '.product-filter-wrapper-mobile .sort-filter-grid ul.sortingForm li', function () {
    $(this).addClass('active').siblings().removeClass('active');
  
    var sort_by = $(this).attr('data-value');

    if (sort_by && sort_by !== 'undefined') {
      var select = $('.collectionsortingForm select[name="sort_by"]');
      
      // Set selected option
      select.find('option').each(function () {
        $(this).prop('selected', $(this).val() === sort_by);
      });
  
      // Trigger the change event
      select.trigger('change');
    }
  });


  $(document).on('click', '.mobileFiltersPopup .main-filter-wrapper .main-filter-grid form.filter-form-mobile .filter-group-display__list-item input[type="checkbox"]', function () {
    const selected_id = $(this).attr('id');
  
    if (selected_id) {
      const isChecked = $(this).is(':checked');
  
      // Loop through checkboxes in the main filter form and sync based on ID
      $('.filter-form .filter-group input[type="checkbox"]').each(function () {
        if ($(this).attr('id') === selected_id) {
          $(this).prop('checked', isChecked);
          $(this).closest('.filter-group-options').find('.filter-group-display__submit input').trigger('click');
        }
      });

      
    }
  });


  $(document).on('click', '.mobileFiltersPopup .main-filter-wrapper .main-filter-grid form.filter-form-mobile .filter-group .filter-group-display__header-reset', function(){
    var filter_for = $(this).closest('.filter-group').attr('data-group-type');
    if(filter_for != '' && filter_for != 'undefined' && filter_for != null){
      $('.filter-form .filter-group[data-group-type="'+filter_for+'"] .filter-group-display__header-reset').trigger('click');
    }
  })


  $(document).on('click', '.mobileFiltersPopup .main-filter-wrapper .main-filter-grid form.filter-form-mobile .active-filters .active-filters__clear', function(){
    $('.filter-form .active-filters__clear').trigger('click');
  })
  
})

function updateAddToCart() {
  const btn = document.querySelector('#sub-button');
  if (btn && !btn.value.trim()) {
    btn.value = btn.getAttribute('data-val') || 'Add to cart';
    return true;
  }
  return false;
}

document.addEventListener('DOMContentLoaded', function() {
  // keep checking until button appears
  const interval = setInterval(() => {
    if (updateAddToCart()) {
      clearInterval(interval);
    }
  }, 300); // check every 0.3s

  // run again on full page load (Shopify sometimes loads slow)
  window.addEventListener('load', updateAddToCart);
});


document.addEventListener("DOMContentLoaded", function () {
    const timers = document.querySelectorAll(".weekly-tuesday-timer");

    timers.forEach(function(timer) {

        const today = new Date();

        // Final deadline (30 June)
        const finalDeadline = new Date(today.getFullYear(), 6, 13, 23, 59, 59, 999);

        let targetDate;

        // If current date is before/equal to June 30
        if (today <= finalDeadline) {

            // Monday = 1 (Sunday = 0)
            let daysUntilMonday = (2 - today.getDay() + 7) % 7;

            // If today is Monday, use next Monday
            if (daysUntilMonday === 0) {
                daysUntilMonday = 7;
            }

            targetDate = new Date(today);
            targetDate.setDate(today.getDate() + daysUntilMonday);
            targetDate.setHours(23, 59, 59, 999);

            // Don't allow weekly reset beyond June 30
            if (targetDate > finalDeadline) {
                targetDate = finalDeadline;
            }

        } else {

            // After June 30 stop at final deadline
            targetDate = finalDeadline;
        }

        timer.setAttribute("data-year", targetDate.getFullYear());
        timer.setAttribute(
            "data-month",
            String(targetDate.getMonth() + 1).padStart(2, "0")
        );
        timer.setAttribute(
            "data-day",
            String(targetDate.getDate()).padStart(2, "0")
        );
    });
});